(ns teamoesterreich.user-mode.prevent.prevent-questionnaire-location-info
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.util.markdown :refer [md]]
    ))






(defn get-it []
  (fn []
    (let [
          selected-questionnaire-cs (r/cursor store/app-state [:state :selected-questionnaire])
          questionnaireId @selected-questionnaire-cs
          questionnaire-cs (r/cursor store/app-state [:questionnaires questionnaireId])

          selected-question-cs (r/cursor store/app-state [:state :selected-questionnaire-question])
          questionId @selected-question-cs
          question-cs (r/cursor questionnaire-cs [:questions questionId])
          question @question-cs

          questionnaire-response-cs (r/cursor store/app-state [:user-questionnaires questionnaireId])
          question-response-cs (r/cursor store/app-state [:user-questionnaires questionnaireId :questions questionId])
          _ (log/out "selected q " @selected-question-cs "->" (clj->js question))
          _ (log/out "qnn-answer? q " (clj->js (when questionnaire-response-cs @questionnaire-response-cs)))
          _ (log/out "q-answer? q " (clj->js (when question-response-cs @question-response-cs)))
          ]
      (log/debug "act-questionnaire " @selected-questionnaire-cs @questionnaire-cs)
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "stretch"
        :spacing    1
        }

       [mui/grid
        {:container false
         :item      true
         :xs        12
         }
        ""]
       [mui/grid
        {:container false
         :item      true
         :lg        7
         :xs        11
         }

        [mui/card {:class-name "wrap-content-card"}

         [mui/card-content
          [mui/typography {:variant "h5"} (:question question)]
          [mui/card-content
           [:div {:dangerouslySetInnerHTML {:__html (.render md (or (:description-long @questionnaire-cs) ""))}
                  :style                   {:min-height "150px" :margin "20px 20px 20px 20px"}
                  :className               "content-preview-widget"}]]
          [:br]

          ]



         [mui/card-actions
          [mui/button
           {:variant   "contained"
            :color     "default"
            :edge      "start"
            :class     "bottom-button"
            :onClick   a/set-page-back
            :startIcon (r/as-element [keyboard-arrow-left])
            }
           "Zurück"]]

         ]]

       ]
      )))

